import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=86f1cc68&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=86f1cc68&prod&lang=scss"
import style1 from "./OfferList.vue?vue&type=style&index=1&id=86f1cc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f1cc68",
  null
  
)

export default component.exports